import React, { useMemo } from "react";
import Logo1 from "../../../assets/images/logo1.png";
import Logo2 from "../../../assets/images/logo2.svg";
import "../../SalesReport/SalesReport.css";
import { useSelector } from "react-redux";
import moment from "moment";

const SalesInvoiceReportHeader = () => {
  const { invoicePrint } = useSelector((state) => state);
  const headerData = invoicePrint?.payload?.data[0];
  const brand = useMemo(() => new URLSearchParams(window.location.search).get("brand"), []);
  const _logo = brand === "DL1961" ? Logo1 : Logo2;
  if (!headerData) return null;
  return (
    <div className="__header">
      <table width="100%">
        <tbody>
          <tr>
            <td width="65%" style={{ paddingRight: "5px" }}>
              <table width="100%">
                <tbody>
                  <tr>
                    <td colSpan={2}>
                      <table width="100%">
                        <tbody>
                          <tr>
                            <td>
                              <div className="__image_container">
                                <img width={250} height={72} src={_logo} alt="Brand Logo" />
                              </div>
                            </td>
                            <td width="100%" style={{ verticalAlign: "top" }}>
                              <div className="__addr">
                                <p>DLPD CANADA LTD.</p>
                                <p>15 Wertheim Court, Suite 409,</p>
                                <p>Richmond Hill, ON L4B 3H7 , Canada</p>
                                <p>Business # : 763395530RT0001</p>
                                <p>Email : orderca@dl1961.com</p>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </td>
                  </tr>
                  <tr>
                    <td width="50%" style={{ paddingRight: "5px" }}>
                      <table width="100%" className="__addr_table">
                        <tbody>
                          <tr>
                            <td>Customer P.O# :</td>
                            <td colSpan={3}>{headerData?.referecne_no || ''}</td>
                          </tr>
                          <tr>
                            <td>Sold To :</td>
                            <td colSpan={3}>{headerData?.bill_to_customer || ''}</td>
                          </tr>
                          <tr>
                            <td>Name :</td>
                            <td colSpan={3}>{(headerData && headerData?.billing_firstname) ? headerData.billing_firstname + ' ' + headerData.billing_lastname : headerData?.customer_name}</td>
                          </tr>
                          <tr>
                            <td>Address 1 :</td>
                            <td colSpan={3}>{headerData?.bill_to_address_1 || ''}</td>
                          </tr>
                          <tr>
                            <td>Address 2 :</td>
                            <td colSpan={3}>{headerData?.bill_to_address_2 || ''}</td>
                          </tr>
                          <tr>
                            <td>City :</td>
                            <td>{headerData?.bill_to_city_name || ''}</td>
                            <td>State :</td>
                            <td>{headerData?.bill_to_state_name || ''}</td>
                          </tr>
                          <tr>
                            <td>Country :</td>
                            <td>{headerData?.bill_to_country || ''}</td>
                            <td>ZIP :</td>
                            <td>{headerData?.bill_to_zip || ''}</td>
                          </tr>
                        </tbody>
                      </table>
                    </td>
                    <td width="50%" style={{ paddingLeft: "5px" }}>
                      <table width="100%" className="__addr_table">
                        <tbody>
                          <tr>
                            <td>Ship To :</td>
                            <td colSpan={5}>{headerData?.ship_to_addressee || ''}</td>
                          </tr>
                          <tr>
                            <td>Name :</td>
                            <td colSpan={5}>
                              {(headerData?.shiping_firstname) ? headerData?.shiping_firstname + ' ' + headerData.shiping_lastname : headerData?.customer_name}
                            </td>
                          </tr>
                          <tr>
                            <td>Address 1 :</td>
                            <td colSpan={5}>{headerData?.ship_to_address_1 || ''}</td>
                          </tr>
                          <tr>
                            <td>Address 2 :</td>
                            <td colSpan={5}>{headerData?.ship_to_address_2 || ''}</td>
                          </tr>
                          <tr>
                            <td>City :</td>
                            <td>{headerData?.ship_to_city_name || ''}</td>
                            <td>State :</td>
                            <td>{headerData?.ship_to_state_name || ''}</td>
                            <td></td>
                            <td></td>
                          </tr>
                          <tr>
                            <td>Country :</td>
                            <td>{headerData?.ship_to_country_name || ''}</td>
                            <td>ZIP :</td>
                            <td>{headerData?.ship_to_zip || ''}</td>
                            <td></td>
                            <td></td>
                          </tr>
                          <tr>
                            <td>Dept :</td>
                            <td>{headerData?.department || ''}</td>
                            <td>DC # :</td>
                            <td>{headerData?.dc_no || ''}</td>
                            <td>Store :</td>
                            <td>{headerData?.store_name || ''}</td>
                          </tr>
                        </tbody>
                      </table>
                    </td>
                  </tr>
                </tbody>
              </table>
            </td>
            <td width="35%" style={{ paddingLeft: "5px", verticalAlign: "top" }}>
              <table width="100%" className="__box">
                <tbody>
                  <tr>
                    <td colSpan={2} className="__heading" align="center">Commercial Invoice
                    </td>
                  </tr>
                  <tr>
                    <td width="40%">Invoice No :</td>
                    <td>
                      DL{headerData?.invoice_header_no}/{moment(headerData?.invoice_date).format("YY")}
                    </td>
                  </tr>
                  <tr>
                    <td>Invoice Date :</td>
                    <td>
                      {moment(headerData?.invoice_date).format("MM/DD/YYYY")}
                    </td>
                  </tr>
                  <tr>
                    <td>Term :</td>
                    <td>
                      {headerData?.term}
                    </td>
                  </tr>
                  <tr>
                    <td>Ship Via :</td>
                    <td>
                      {headerData?.ship_via}
                    </td>
                  </tr>
                  <tr>
                    <td>Pick Ticket # :</td>
                    <td>
                      {headerData?.ship_header_no}
                    </td>
                  </tr>
                  <tr>
                    <td>Order No :</td>
                    <td>
                      {headerData?.sale_order_no}
                    </td>
                  </tr>
                  <tr>
                    <td>Vendor No :</td>
                    <td>
                    </td>
                  </tr>
                  <tr>
                    <td>Boxes No :</td>
                    <td>
                    </td>
                  </tr>
                </tbody>
              </table>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default SalesInvoiceReportHeader;
